export interface Column {
  readonly name: string
}

export interface Row {
  readonly cells: Cell[]
}

export interface Cell {
  readonly type: CellType
  readonly content: string
}

export enum CellType {
  TEXT = 'TEXT',

  IMAGE = 'IMAGE',
}
